module.exports = __webpack_public_path__ + "img/markers.7effcd96.png";